var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('img',{attrs:{"src":require("../../assets/titan-logo-inverted.svg"),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.$t("purchaseFlow.secure"))+" ")])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }